import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "layout",
  class: "layout"
}
const _hoisted_2 = { class: "inner-wrapper" }
const _hoisted_3 = {
  id: "innerBanner",
  class: "inner-banner"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { id: "toDoWidget" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Alert = _resolveComponent("Alert")!
  const _component_SubscriptionBanner = _resolveComponent("SubscriptionBanner")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_UpgradePlanWithoutPermission = _resolveComponent("UpgradePlanWithoutPermission")!

  return (_ctx.currentUser?.emailVerified)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Header),
        _createVNode(_component_Alert),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.showSubscriptionBanner)
              ? (_openBlock(), _createBlock(_component_SubscriptionBanner, {
                  key: 0,
                  trialEndDate: _ctx.trialEndDate
                }, null, 8, ["trialEndDate"]))
              : _createCommentVNode("", true)
          ]),
          (_openBlock(), _createElementBlock("div", {
            id: "mainContent",
            key: _ctx.forceUpdateLayout,
            class: "inner"
          }, [
            _createVNode(_component_router_view)
          ])),
          _hoisted_4
        ]),
        _createVNode(_component_Footer),
        (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
          _createVNode(_component_UpgradePlanWithoutPermission)
        ]))
      ]))
    : _createCommentVNode("", true)
}